import { useCohortInfo } from 'hooks/useCohortInfo'
import { useExperimentalFeatures } from 'hooks/useExperimentalFeatures'

import { getUpsellConfig } from 'modules/purchase/helpers/getUpsellConfig'
import { PARENTING_UPSELL_V2_OVERRIDE } from 'modules/purchase/pages/Upsell/components/CommonUpsell/constants'

import { Cohort } from 'root-constants'

export const useUpsellConfig = () => {
  const { cohortToUse } = useCohortInfo()
  const { isAyah103ParentingUpsellTest } = useExperimentalFeatures()
  const upsellConfig = getUpsellConfig(cohortToUse)

  if (
    isAyah103ParentingUpsellTest &&
    cohortToUse === Cohort.AP_PARENTING_313_C
  ) {
    return { ...upsellConfig, ...PARENTING_UPSELL_V2_OVERRIDE }
  }

  return upsellConfig
}
